import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=67a7a2c8&"
import script from "./Instructor.vue?vue&type=script&lang=js&"
export * from "./Instructor.vue?vue&type=script&lang=js&"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=67a7a2c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports